import React from "react";
import PageLayout from "../components/PageLayout";
import SearchHeader from "../components/SearchHeader";
import UserAdd from "../components/user/UserAdd";

const AddUserPage = () => {
  return (
    <PageLayout>
      <SearchHeader />
      <div className="inner-main-content">
        <UserAdd />
      </div>
    </PageLayout>
  );
};

export default AddUserPage;
